import { call, put } from "redux-saga/effects";
import { courseAPI } from "@services/api";
import { getNewestCoursesActions } from "../slices";

function* getNewestCoursesWorker() {
  try {
    yield put(getNewestCoursesActions.pending());
    const response = yield call(courseAPI.exploreCourse, {
      Orderby: "createdAt desc",
      PageSize: 30,
      PageNumber: 1,
      status: 1,
      IsActive: true,
      IsPurchased: false,
      IsEnrollemt: false,
    });
    yield put(getNewestCoursesActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getNewestCoursesActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getNewestCoursesWorker };
